<script setup>
import KuisionerForm from './KuisionerForm.vue';


</script>

<template>
  <div>
    <KuisionerForm />
  </div>
</template>